import { App } from "./containers/App";
import "./globalStyles.scss";

import { createRoot } from 'react-dom/client';

createRoot(document.getElementById('root')).render(<App />);